// extracted by mini-css-extract-plugin
export default {"bottomNav":"bottomNav_bottomNav__S3f8n","navItem":"bottomNav_navItem__PgjC-","active":"bottomNav_active__DmUbr","loading":"bottomNav_loading__ngPkw"};